import React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';

import LeftChevron from './LeftChevron';

const Button = styled.button`
  color: ${props => props.theme.primary};
  fill: ${props => props.theme.primary};
  width: 140px;
  height: 50px;
  font-size: 14px;
  background: none;
  border: none;
  white-space: nowrap;
  text-align: left;
  curspor: pointer;
`;

const Underlined = styled.span`
  padding-bottom: 5px;
  border-bottom: solid 0.1px;
  margin-left: 7px;
`;

const Chevron = styled.span`
  margin-left: 32px;
`;

const PrevPageButton = ({ t, ...others }) => (
  <Button {...others}>
    <Chevron>
      <LeftChevron />
    </Chevron>
    <Underlined>{t('button.previous')}</Underlined>
  </Button>
);

export default translate()(PrevPageButton);
